import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import React from 'react'
import { CryptoState } from '../ContextApi'
import { numberWithCommas } from './Carousel/Carousel';

const SideBar = ({coin}) => {
  console.log(coin)

  const {symbol, currency}= CryptoState();
  var curr= currency.toLowerCase();
  
  
  return (<>
    {!coin?<>loading</>:(
    <div>{coin?.symbol.toUpperCase()} Price Statistics<br/>
<TableContainer style={{marginTop:15}}>
<Table style={{minWidth:200}} aria-label="simple table">
  
<TableBody>
<TableRow >
<TableCell component="th" scope="row">
Market Cap Rank
</TableCell>
<TableCell align="right" style={{fontWeight:700, fontSize:16}}>
{coin?.market_data.market_cap_rank}
</TableCell>
</TableRow>
<TableRow  >
<TableCell component="th" scope="row">
Bitcoin Price	
</TableCell>
<TableCell align="right" style={{fontWeight:700, fontSize:16}}>
{symbol}{numberWithCommas(coin?.market_data.current_price[curr].toFixed(2))}
</TableCell>
</TableRow >
<TableRow  >
<TableCell component="th" scope="row">
Market Cap

</TableCell>
<TableCell align="right" style={{fontWeight:700, fontSize:16}}>
{symbol}{numberWithCommas(coin?.market_data.market_cap[curr])}
</TableCell>
</TableRow>
<TableRow  >
<TableCell component="th" scope="row">
Total Volume	
</TableCell>
<TableCell align="right" style={{fontWeight:700, fontSize:16}}>
{symbol}{numberWithCommas(coin?.market_data.total_volume[curr])} 
</TableCell>
</TableRow>
<TableRow  >
<TableCell component="th" scope="row">
 24h High 
</TableCell>
<TableCell align="right" style={{fontWeight:700, fontSize:16}}>
{symbol}{numberWithCommas(coin?.market_data.high_24h[curr])}
</TableCell>
</TableRow>
<TableRow  >
<TableCell component="th" scope="row">
24h Low
</TableCell>
<TableCell align="right" style={{fontWeight:700, fontSize:16}}>
{symbol}{numberWithCommas(coin?.market_data.low_24h
[curr])}
</TableCell>
</TableRow>


</TableBody>


</Table>


</TableContainer>


    </div>)}</>
  )
}

export default SideBar